import { differenceInCalendarMonths, differenceInDays } from "date-fns";

import DateRangeType from "@app/scene/reports/enums/DateRangeType";

export type Granularity = "day" | "hour" | "month" | "week";

// Drives both the BE aggregation period (sagas) and the chart's bar bucketing
// (TrendChart). Period type is the source of truth — Sunday's "Current Week"
// looks identical to "Today" by date alone, but the user picked the week so the
// chart must show daily bars, not hourly. Custom is the only branch that has to
// fall back to range length because there is no semantic period to read.
export const getGranularity = (
  dateRangeType: DateRangeType,
  startDate: Date,
  endDate: Date
): Granularity => {
  switch (dateRangeType) {
    case DateRangeType.CUSTOM: {
      if (differenceInDays(endDate, startDate) <= 1) {
        return "hour";
      }
      const months = differenceInCalendarMonths(endDate, startDate);
      if (months < 2) {
        return "day";
      }
      if (months < 12) {
        return "week";
      }
      return "month";
    }
    case DateRangeType.LAST_WEEK:
    case DateRangeType.PREVIOUS_MONTH:
    case DateRangeType.THIS_MONTH:
    case DateRangeType.THIS_WEEK:
      return "day";
    case DateRangeType.TODAY:
    case DateRangeType.YESTERDAY:
      return "hour";
  }
};
